import styled from "styled-components";

export const MenuPanelWidgetStyled = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  column-gap: 19px;
  row-gap: 15px;
  .menu_item_wrap {
    flex-basis: calc(33.33% - 20px);
  }
`;
